import { Checklist } from "@mui/icons-material";
import { SubtypeToolboxPlaceholderScaffold } from "../../../pages/actionModules/ActionModuleEditor/SubtypeEditor/SubtypeToolbox";
import { SubtypeDefinition } from "../actionModule";
import { SubtypeState, PropertyTypes } from "../editor/subtypeEditorTypes";
import { ChecklistAnswerItem, ChecklistAnswerSubtypeDataModel, ChecklistAnswerSubtypeResponse } from "./checklistAnswerSubtype";
import { Subtype } from "./subtype";
import { ChecklistAnswerItemsEditor } from "../../../components/actionModules/subtypes/checklistAnswer/ChecklistAnswerItemsEditor";
import { ChecklistAnswerTypeEditor } from "../../../components/actionModules/subtypes/checklistAnswer/ChecklistAnswerTypeEditor";
import { ChecklistAnswerEditorPreview } from "../../../components/actionModules/subtypes/checklistAnswer/ChecklistAnswerEditorPreview";
import ChecklistAnswerSubtypeSummary from "../../../pages/incentivation/actionModules/incentivationTable/subtype/summary/ChecklistAnswerSubtypeSummary";
import ChecklistAnswerSubtypeDetails from "../../../pages/incentivation/actionModules/incentivationTable/subtype/details/ChecklistAnswerSubtypeDetails";

export const ChecklistAnswerSubtype: SubtypeDefinition = {
    name: "actionModules.subtypes.checklistAnswer.name",
    type: Subtype.ChecklistAnswerModuleSubtype,
    icon: <Checklist />,
    toolboxPlaceholder: () => <SubtypeToolboxPlaceholderScaffold
        icon={<Checklist />}
        name="actionModules.subtypes.checklistAnswer.name" />,
    editorPreview: (state: SubtypeState) => <ChecklistAnswerEditorPreview state={state}/>,
    subtypeDataView: (props) => <ChecklistAnswerSubtypeDetails
                subtype={props.subtype as ChecklistAnswerSubtypeResponse}
                subtypeData={props.subtypeData as ChecklistAnswerSubtypeDataModel} />,
    subtypeDataSummaryView: (props) => <ChecklistAnswerSubtypeSummary
                subtype={props.subtype as ChecklistAnswerSubtypeResponse}
                subtypeData={props.subtypeData as ChecklistAnswerSubtypeDataModel} />,
    editableProperties: [
        {
            name: "checklistAnswerType",
            displayName: "actionModules.subtypes.checklistAnswer.checklistAnswerType",
            propertyType: PropertyTypes.complex,
            defaultValue: "SingleChoice",
            editor: (props) => <ChecklistAnswerTypeEditor {...props} />,
        },
        {
            name: "checklistItems",
            displayName: "actionModules.subtypes.checklistAnswer.checklistItems",
            propertyType: PropertyTypes.complex,
            defaultValue: [
                {
                    negativeCheckedReward: 0,
                    positiveCheckedReward: 0,
                    notCheckedReward: 0,
                    text: "Auswahl 1",
                    id: 0,
                },
                {
                    negativeCheckedReward: 0,
                    positiveCheckedReward: 0,
                    notCheckedReward: 0,
                    text: "Auswahl 2",
                    id: 1,
                },
                {
                    negativeCheckedReward: 0,
                    positiveCheckedReward: 0,
                    notCheckedReward: 0,
                    text: "Auswahl 3",
                    id: 2,
                },
            ] as ChecklistAnswerItem[],
            editor: (props) => <ChecklistAnswerItemsEditor {...props} />,
        },
    ]
};